// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"70":"a5b85de7","171":"b088a448","256":"b1582971","640":"a66844ae"}[chunkId] + ".js";
};